module.exports = __webpack_public_path__ + "static/media/skill.5a6f33c5.svg";